/**
 * Main application entry point.
 *
 * @author Stanislav Kalashnik <sk@infomir.eu>
 * @license GNU GENERAL PUBLIC LICENSE Version 3
 */

'use strict';

var app    = require('mag-app');


// main application events
app.addListeners({
    // all resources are loaded
    load: function load () {
        // set pages
        app.pages = {
            main: require('./pages/main')
        };
        // router.init([
        //     require('./pages/init'),
        //     require('./pages/main')
        // ]);
        app.ready();
        app.route(app.pages.main);
    }
});
